import React from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";
import CustomBorder from "../_UI/customBorder";
import {useNavigate} from "react-router-dom";



const TeamS3 = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const contentHandler = () =>{
        return (
            <div className={`${Styles.posWrap}`}>
                <div className={`${Styles.title}`}>{t('ИДЕЯ КОМАНДЫ')}</div>
                <div className={`${Styles.subTitle}`}>{('Команда TimeCapsule объединена одной идеей')}:</div>
                <div className={`${Styles.note}`}>{t('Создать первую в истории технологическую инфраструктуру для сохранения и продолжения человеческой индивидуальности вне биологической формы.')}</div>
                <div className={`${Styles.btnWrap}`}>
                    <CustomBorder corners={{ topRight: true, bottomLeft: true }} withHover={true}>
                        <button className={`${Styles.btn}`} onClick={()=>{navigate('/sign-in')}}><div>{t('Стать частью цифровой цивилизации')}</div></button>
                    </CustomBorder>
                </div>
            </div>
        )
    }

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentBox} ${Styles.contentBoxM}`}>
                    <CustomBorder corners={{}} fill="#151729">
                        {contentHandler()}
                    </CustomBorder>
                </div>
                <div className={`${Styles.contentBox} ${Styles.contentBoxD}`}>
                    <CustomBorder corners={{ bottomLeft: true, topRight: true }} cutSize={15} fill="#151729">
                        {contentHandler()}
                    </CustomBorder>
                </div>
            </div>
        </section>
    );
};

export default TeamS3;